<template>
  <div
    class="FillInInfo"
    v-if="FillInInfoFlag && this.$store.state.discount > 0"
  >
    <div
      class="seeBigPicture"
      @click="seeBigPictureFlag = false"
      v-if="seeBigPictureFlag"
    >
      <img :src="bigPicture" alt="" />
    </div>
    <div class="productInfoList">
      <div class="productInfo" v-for="item in shoppingCartInfo" :key="item.id">
        <div class="product-icon">
          <img src="../../assets/images/updataFile/ProductList-icon.png" />
        </div>
        <div class="product-name">{{ item.productName }}</div>
        <div class="product-price"></div>
        <div class="product-price">
          <div
            style="text-decoration: line-through; color: #aaa"
            v-if="$store.state.discount < 100"
          >
            ￥{{ item.productPrice }}
          </div>
          <div>￥{{ calculationDiscount(item.productPrice) }}</div>
        </div>
      </div>
    </div>
    <!-- 用户信息 -->
    <div class="fillInUserInfo">
      <div class="userInfo-list">
        <div class="item">
          <div class="key">受检人姓名</div>
          <div class="value">
            <input
              type="text"
              @blur="inputBlur"
              v-model="fillInInfo.examineeName"
              placeholder="请输入受检人姓名"
            />
          </div>
        </div>
        <div class="item sex">
          <div class="key">性别</div>
          <div class="value">
            <div
              @click="sexToggle('男')"
              :class="['man', fillInInfo.examineeSex == '男' ? 'active' : '']"
            >
              男
            </div>
            <div
              @click="sexToggle('女')"
              :class="['woman', fillInInfo.examineeSex == '女' ? 'active' : '']"
            >
              女
            </div>
          </div>
        </div>
        <div class="item">
          <div class="key">手机号码</div>
          <div class="value">
            <input
              type="tel"
              @blur="inputBlur"
              placeholder="请输入手机号码"
              v-model="fillInInfo.examineeMobile"
            />
          </div>
        </div>
        <div class="item">
          <div class="key">年龄</div>
          <div class="value">
            <input
              type="text"
              min="0"
              max="100"
              @blur="inputBlur"
              @input="inputAge"
              placeholder="请输入年龄"
              v-model="fillInInfo.age"
            />
          </div>
        </div>
        <div class="item">
          <div class="key">邮箱</div>
          <div class="value">
            <input
              type="email"
              @blur="inputBlur"
              placeholder="请输入邮箱用于接收报告"
              v-model="fillInInfo.email"
            />
          </div>
        </div>
        <div class="item">
          <div class="key">住院号</div>
          <div class="value">
            <input
              type="tel"
              @blur="inputBlur"
              placeholder="请输入住院号"
              v-model="fillInInfo.hospitalNumber"
            />
          </div>
        </div>
        <div class="item">
          <div class="key">送检医生</div>
          <div class="value">
            <input
              type="tel"
              @blur="inputBlur"
              placeholder="请输入送检医生"
              v-model="fillInInfo.inspectionDoctors"
            />
          </div>
        </div>
        <div class="item">
          <div class="key">门诊号</div>
          <div class="value">
            <input
              type="tel"
              @blur="inputBlur"
              placeholder="请输入门诊号"
              v-model="fillInInfo.clinicNumber"
            />
          </div>
        </div>
        <!-- <div
          class="item"
          style="height:auto;"
        >
          <div class="key">初步诊断</div>
          <div
            class="value"
            style="padding-top: 0.5rem;"
          >
            <textarea
              @blur="inputBlur"
              placeholder="请输入初步诊断"
              v-model="fillInInfo.initialDiagnosis"
            ></textarea>
          </div>
        </div> -->
        <div
          class="item"
          style="display: block; height: auto; padding-bottom: 0.4rem"
        >
          <div class="key">病历照片</div>
          <div class="fileBox" v-for="(item, index) in imgList" :key="item">
            <div class="shut" @click="delUpload(item, index)">
              <img
                src="../../assets/images/updataFile/payment-error.png"
                alt="关闭"
              />
            </div>
            <div class="fileSuccessImg" @click="setBigPicture(item)">
              <img :src="item" />
            </div>
          </div>
          <div class="fileBox" @change="UpladFile">
            <input id="file" type="file" accept="image/*" />
            <div class="none"></div>
            <div class="fileTxt">
              <img src="../../assets/images/updataFile/fileImgIcon.png" />
              <div>点击上传</div>
            </div>
            <div class="none"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 发票 -->
    <div class="invoice">
      <router-link class="item" to="/invoice">
        <div class="left">发票</div>
        <div class="right">
          <div
            class="txt"
            :style="{ color: userInvoice.type != 0 ? '#222' : '' }"
          >
            {{
              userInvoice.type == 0
                ? "不开发票"
                : userInvoice.rise == 2
                ? "企业"
                : "个人"
            }}
          </div>
          <img src="../../assets/images/updataFile/arrow-right-chu-icon.png" />
        </div>
      </router-link>
    </div>
    <div class="TickBox">
      <div class="tick">
        <div :class="{ select: true, active: selectFlag }" @click="selectFun">
          <img src="../../assets/images/updataFile/select-active.png" />
          <div class="noActive"></div>
        </div>
        <div class="txt">
          我已阅读并同意执行<span @click="toggleTYS"
            >《用户检测知情同意书》</span
          >
        </div>
      </div>
    </div>
    <!-- 底部客服及支付 -->
    <div
      class="bottom-content"
      v-if="btnFlag"
      :style="{
        width: this.$store.state.PCFlag ? '11.04rem' : '',
        margin: '0 auto',
      }"
    >
      <div class="monery" style="display: flex">
        <div class="total">共{{ shoppingCartInfo.length }}项，合计：</div>
        <div class="presentPrice">
          <span>￥</span>
          <span v-if="userInvoice.type == 0">{{
            calculationDiscount(allPrice)
          }}</span>
          <span v-else>
            {{ calculationDiscount(allPrice + allPrice * 0.06) }}
          </span>
        </div>
      </div>
      <div
        :class="{ purchase: true, active: selectFlag }"
        @click="placeAnOrder"
      >
        提交订单
      </div>
    </div>
    <div
      class="TYSContentBox"
      @touchmove.stop.prevent="touchstartReturn"
      v-show="TYSFlag"
    >
      <div class="TYSMask"></div>
      <div class="TYSContent">
        <div class="TYSTitle">
          知情同意书
          <div class="shutIcon" @click="TYSFlag = false">
            <img src="../../assets/images/updataFile/shutIcon.png" />
          </div>
        </div>
        <div class="TYSList">
          1、我保证所提供的个人信息真实有效，本人愿意承担因填写虚假信息所带来的一切责任和后果；
          <br />2、我已充分了解且同意本检测的目的及局限性和风险；
          <br />3、我知哓且同意检测机构不负责检测后所产生的我心理上、法律上及应用方面的任何后果；
          <br />4、我知哓且同意该检测结果仅作为参考依据，不作为临床诊断依据；
          <br />5、我知哓且同意、样本采集及运输过程中可能导致的破损、污染等情形需重新检测，我同意配合重新检测事宜；
          <br />6、我知哓且同意、样本检测报告可能存在笔误等文本错误，于不实质性影响检测结果的笔误我予以原谅、和认可;
          <br />7、我同意检测机构处理本次检测涉及的样本及医疗废弃物；
          <br />8、我同意检测机构与我联系获取随访信息；
          <br />9、我同意在保护个人隐私的前提下，检测机构及合作单位可使用本次检测数据开展科学研究、发表学术论文。
        </div>
        <div class="TYSPs">
          本人已认真阅读本知情书的相关内容，并知悉可能存在的局限性、风险性和注意事项，自愿签署本知情同意书。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import exif from "exif-js";
export default {
  data() {
    return {
      FillInInfoFlag: true,
      /* 用户信息 */
      userInfo: {},
      /* 产品详情 */
      productDetails: {},
      shoppingCartInfo: [],
      allPrice: "",
      selectFlag: false,
      TYSFlag: false,
      birthdayOriginal: "",
      fillInInfo: {
        examineeSex: "男",
      },
      imgList: [],
      bigPicture: "",
      seeBigPictureFlag: false,
      userInvoice: {
        type: 0,
        rise: 0,
      },
      btnFlag: true,
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      if (localStorage.getItem("fillInInfo")) {
        try {
          this.fillInInfo = JSON.parse(localStorage.getItem("fillInInfo"));
        } catch (error) {
          this.fillInInfo = {
            examineeSex: "男",
          };
        }
      }

      if (sessionStorage.getItem("localStorageImgList")) {
        this.imgList = JSON.parse(
          sessionStorage.getItem("localStorageImgList")
        );
      }
      if (sessionStorage.getItem("selectFlag"))
        this.selectFlag = sessionStorage.getItem("selectFlag");
      if (sessionStorage.getItem("invoice"))
        this.userInvoice = JSON.parse(sessionStorage.getItem("invoice"));
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let ids = this.$route.query.ids;
      this.getProductDetails(ids);
    } else {
      this.$goLogin();
    }
    if (!this.$store.state.wxConfigFlag) this.$wxConfig();
  },
  methods: {
    inputAge(val) {
      if (this.fillInInfo.age < 0) {
        this.$set(this.fillInInfo, "age", 0);
      } else if (this.fillInInfo.age > 100) {
        this.$set(this.fillInInfo, "age", 100);
      }
    },
    /**
     *出现加载中的时候不让滚动
     */
    touchstartReturn() {
      return;
    },
    /**
     * 同意书的展开收起
     */
    toggleTYS() {
      this.TYSFlag = !this.TYSFlag;
    },
    /**
     * 勾选同意执行
     */
    selectFun() {
      this.selectFlag = !this.selectFlag;
      sessionStorage.setItem("selectFlag", this.selectFlag);
    },
    /**
     * 失去焦点缓存表单
     */
    inputBlur() {
      localStorage.setItem("fillInInfo", JSON.stringify(this.fillInInfo));
    },
    /**
     * 切换性别
     */
    sexToggle(examineeSex) {
      let data = this.fillInInfo;
      if (examineeSex != data.examineeSex) {
        this.$set(this.fillInInfo, "examineeSex", examineeSex);
        this.inputBlur();
      }
    },
    /**
     * 根据ids获取产品信息
     */
    getProductDetails(ids) {
      this.$http
        .get(`/shoppingCart/getByIds`, {
          params: {
            getByIds: ids,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            let list = res.data.data;
            let allPrice = 0;
            for (let i = 0; i < list.length; i++) {
              allPrice += list[i].productPrice;
            }
            this.shoppingCartInfo = list;
            this.allPrice = allPrice;
          }
        });
    },
    /* 下单 */
    placeAnOrder() {
      let shoppingCartCreateOrderModel = this.fillInInfo;
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let phoneRes = /^1[0-9]{10}$/;
        let emailRes =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!shoppingCartCreateOrderModel.examineeName)
          this.$toots("受检人姓名不能为空");
        else if (!shoppingCartCreateOrderModel.examineeMobile)
          this.$toots("手机号码不能为空");
        else if (!phoneRes.test(shoppingCartCreateOrderModel.examineeMobile))
          this.$toots("请输入正确的手机号");
        else if (!shoppingCartCreateOrderModel.age) this.$toots("年龄不能为空");
        else if (!shoppingCartCreateOrderModel.email)
          this.$toots("邮箱不能为空");
        else if (!emailRes.test(shoppingCartCreateOrderModel.email))
          this.$toots("请确认邮箱是否正确");
        // else if (!shoppingCartCreateOrderModel.hospitalNumber)
        //   this.$toots("住院号不能为空");
        // else if (!shoppingCartCreateOrderModel.clinicNumber)
        //   this.$toots("门诊号不能为空");
        // else if (!shoppingCartCreateOrderModel.initialDiagnosis)
        //   this.$toots("初步诊断不能为空");
        // else if (this.imgList.length == 0) this.$toots("病历照片不能为空");
        else if (!this.selectFlag) this.$toots("请勾选用户检测知情同意书");
        else {
          this.$loading();
          let query = this.$route.query;
          shoppingCartCreateOrderModel.ids = query.ids;
          shoppingCartCreateOrderModel.openId = query.openId;
          shoppingCartCreateOrderModel.doctorsId =
            localStorage.getItem("doctorId");
          try {
            shoppingCartCreateOrderModel.medicalRecordPhoto =
              this.imgList.join(",");
          } catch (err) {}
          shoppingCartCreateOrderModel.userId = this.userInfo.id;
          shoppingCartCreateOrderModel.userInvoice = this.userInvoice;
          this.$http
            .post(
              `/userOrder/shoppingCartCreateOrder`,
              shoppingCartCreateOrderModel,
              {
                qs: "no",
              }
            )
            .then((res) => {
              if (res.data.code == 200) {
                let orderNo = res.data.data;
                this.$store.state.closureFlag = true;
                if (this.$isWeixin()) this.wxPayment(orderNo, query.openId);
                else this.h5Payment(orderNo);
              } else this.$toots("系统正在升级，请稍后");
            })
            .catch((err) => {
              this.$toots("系统正在升级，请稍后");
            });
        }
      }
    },

    /**
     * 调用h5微信支付前判断是否安装微信
     */
    h5Payment(orderNo) {
      let data = { orderNo: orderNo };
      this.$http
        .post(`/api/hospital/WeChat/wxClientCreateOrder`, data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$store.state.loadingFlag = false;
            location.href = res.data.data.mwebUrl;
          }
        });
    },
    /**
     * 调用微信支付
     */
    wxPayment(orderNo, openId) {
      this.$http
        .post(
          `/wechat/createOrder`,
          { orderNo: orderNo, openId: openId },
          { qs: "no" }
        )
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let nonceStr = data.nonceStr;
            let packageValue = data.packageValue;
            let paySign = data.paySign;
            let timeStamp = data.timeStamp;
            let signType = data.signType;
            this.wx.chooseWXPay({
              timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
              package: packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: paySign, // 支付签名
              success: (res) => {
                // 支付成功后的回调函数
                this.$store.state.loadingFlag = false;
                this.$store.state.closureFlag = true;
                this.$router.replace({
                  name: "PaymentSuccess",
                  query: {
                    orderNo: orderNo,
                    openId: openId,
                  },
                });
              },
              fail: (err) => {
                this.$toots("系统正在升级，请稍后");
              },
              cancel: (cancel) => {
                this.$toots("取消支付");
              },
            });
          } else if (res.data.code == 500) this.$toots(res.data.msg);
          else {
            this.$toots("系统正在升级，请退出后重新操作");
          }
          this.$store.state.loadingFlag = false;
        })
        .catch((err) => {
          this.$toots("系统正在升级，请稍后");
        });
    },
    setBigPicture(src) {
      this.bigPicture = src;
      this.seeBigPictureFlag = true;
    },
    /**
     * base64 转file图片
     */
    convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    /**
     * 上传图片input   chang回调
     */
    UpladFile(e) {
      var _this = this;
      var file = e.target.files[0],
        reader = new FileReader(),
        Orientation = 0,
        image = new Image();
      e.value = null;
      if (file) {
        this.$loading("上传中");
        exif.getData(file, function () {
          Orientation = exif.getTag(this, "Orientation");
        });
        reader.onload = function (ev) {
          image.src = ev.target.result;
          image.onload = function () {
            var imgWidth = this.width / 2.1,
              imgHeight = this.height / 2.1;
            // 控制上传图片的宽高
            var canvas = document.createElement("canvas"),
              ctx = canvas.getContext("2d");
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            if (Orientation && Orientation != 1) {
              switch (Orientation) {
                case 6: // 旋转90度
                  canvas.width = imgHeight;
                  canvas.height = imgWidth;
                  ctx.rotate(Math.PI / 2);
                  // (0,-imgHeight) 从旋转原理图那里获得的起始点
                  ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
                  break;
                case 3: // 旋转180度
                  ctx.rotate(Math.PI);
                  ctx.drawImage(
                    this,
                    -imgWidth,
                    -imgHeight,
                    imgWidth,
                    imgHeight
                  );
                  break;
                case 8: // 旋转-90度
                  canvas.width = imgHeight;
                  canvas.height = imgWidth;
                  ctx.rotate((3 * Math.PI) / 2);
                  ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
                  break;
              }
            } else ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
            var file = _this.convertBase64UrlToBlob(
              canvas.toDataURL("image/png", 0.8)
            );
            var form = new FormData();
            form.append(
              "file",
              file,
              "file_" + Date.parse(new Date()) + ".png"
            );
            _this.$http
              .post(`/uploadFile/uploadFile`, form, { qs: "no" })
              .then((res) => {
                if (res.data.code == 200) {
                  document.getElementById("file").value = "";
                  _this.$store.state.loadingFlag = false;
                  let list = _this.imgList;
                  list.push(res.data.data);
                  sessionStorage.setItem(
                    "localStorageImgList",
                    JSON.stringify(list)
                  );
                  _this.imgList = list;
                } else _this.$toots("系统正在升级，请稍后");
              })
              .catch((err) => {
                _this.$toots("系统正在升级，请稍后");
              });
          };
        };
        reader.readAsDataURL(file);
      }
    },
    /**
     *根据名称删除体检报告
     */
    delUpload(url, index) {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let fileName = url.split("com/");
        this.$loading("删除中");
        this.$http
          .delete(`/uploadFile/delete/${fileName}`)
          .then((res) => {
            if (res.data.code == 200) {
              this.$toots("删除成功");
              let list = this.imgList;
              list.splice(index, 1);
              if (list.length > 0)
                sessionStorage.setItem(
                  "localStorageImgList",
                  JSON.stringify(list)
                );
              else sessionStorage.removeItem("localStorageImgList");
              this.imgList = list;
            } else this.$toots("系统正在升级，请稍后");
          })
          .catch((err) => {
            this.$toots("删除成功");
            let list = this.imgList;
            list.splice(index, 1);
            if (list.length > 0)
              sessionStorage.setItem(
                "localStorageImgList",
                JSON.stringify(list)
              );
            else sessionStorage.removeItem("localStorageImgList");
            this.imgList = list;
          });
      }
    },
  },
  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
  },
};
</script>
<style lang="less" scoped>
.FillInInfo {
  padding-bottom: 137px;
  background-color: #f8f8f8;
  .seeBigPicture {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background-color: #000;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
    }
  }
  // 产品信息
  .productInfoList {
    padding: 30px 30px 0 30px;
    .productInfo {
      margin-top: 20px;
      padding: 30px;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .product-icon {
        width: 100px;
        height: 70px;
        img {
          width: 50px;
          height: 70px;
          display: block;
          margin: 0 auto;
        }
      }
      .product-name {
        text-align: justify;
        flex: 1;
        font-size: 34px;
        font-weight: 700;
      }
      .product-price {
        padding-left: 20px;
        color: #ef2538;
        font-size: 32px;
      }
    }
    .productInfo:first-child {
      margin-top: 0;
    }
  }
  // 用户信息
  .fillInUserInfo {
    .userInfo-list {
      background-color: #fff;
      padding-left: 30px;
      padding-right: 30px;
      border-radius: 6px;
      // 选择性别单独样式
      .item.sex {
        .value {
          display: flex;
          align-items: center;
          position: relative;
          > div:first-child {
            margin-right: 30px;
          }
          > div {
            width: 160px;
            height: 60px;
            line-height: 60px;
            font-size: 28px;
            text-align: center;
            border-radius: 60px;
            border: 2px solid #e6e6e6;
          }
          .active {
            background-color: #1968a8;
            color: #fff;
            border: none;
          }
        }
      }
      // 最后一个元素不显示边框
      .item:last-child {
        border-bottom: none;
      }
      // 有箭头的单独样式
      .item.arrow {
        .value {
          display: flex;
          justify-content: space-between;
          img {
            width: 16px;
            height: 26px;
            margin-top: 41px;
          }
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 118px;
        line-height: 118px;
        border-bottom: 1px solid #ebebeb;
        font-size: 28px;
        .key {
          width: 200px;
          font-size: 30px;
          color: #222;
        }
        .value {
          flex: 1;
          position: relative;
          .company {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-50%, -50%);
            font-size: 30px;
            color: #aaa;
          }
          textarea {
            resize: none;
            padding: 20px 10px 20px 20px;
            font-size: 30px;
            color: #222;
            width: 100%;
            min-height: 140px;
            border: 1px dashed #bbb;
            border-radius: 6px;
          }
          textarea::placeholder {
            font-size: 30px;
            color: #ccc;
          }
          input {
            font-size: 30px;
            color: #222;
            opacity: 1;
          }
          input::placeholder {
            font-size: 30px;
            color: #ccc;
          }
        }
        .fileBox {
          margin-bottom: 30px;
          height: 340px;
          border: 1px dashed #bbb;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          .fileSuccessImg {
            height: 100%;
            border-radius: 10px;
            overflow: hidden;
            img {
              border-radius: 10px;
              // width:100%;
              height: 100%;
              display: block;
              margin: 0 auto;
            }
          }
          .shut {
            position: absolute;
            top: -30px;
            right: -30px;
            width: 60px;
            height: 60px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
          .none {
            flex: 1;
          }
          .fileTxt {
            line-height: 40px;
            text-align: center;
            color: #b8b8b8;
            font-size: 24px;
            img {
              // display: block;
              width: 48px;
              height: 42px;
              // margin: 0 auto;
            }
          }
        }
      }
    }
  }
  .uploadData,
  .fillInUserInfo,
  .invoice,
  .TickBox {
    margin-top: 20px;
    padding-left: 30px;
    padding-right: 30px;
  }
  // 发票
  .invoice {
    .item {
      display: flex;
      justify-content: space-between;
      height: 108px;
      line-height: 108px;
      background-color: #fff;
      padding-left: 30px;
      padding-right: 30px;
      font-size: 28px;
      border-radius: 6px;
      .left {
        width: 200px;
      }
      .right {
        flex: 1;
        color: #ccc;
        display: flex;
        justify-content: space-between;
        position: relative;
        .txt {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 200px;
          margin-right: 26px;
        }
        img {
          width: 16px;
          height: 26px;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
  .TickBox {
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    .tick {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 108px;
      background-color: #fff;
      border-radius: 6px;
      padding-left: 30px;
    }
    .select {
      .noActive {
        width: 38px;
        height: 38px;
        border-radius: 100%;
        border: 1px solid #bbbbbb;
      }
      img {
        display: none;
        width: 38px;
        height: 38px;
      }
    }
    .select.active {
      img {
        display: block;
      }
      .noActive {
        display: none;
      }
    }
    .txt {
      flex: 1;
      text-align: left;
      padding-left: 30px;
      font-size: 28px;
      span {
        color: #1968a8;
      }
    }
  }
  .TYSContentBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .TYSMask {
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .TYSContent {
      transition: all 1s;
      position: absolute;
      left: 0;
      bottom: 0;
      max-height: 100%;
      overflow: auto;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background-color: #fff;
      text-align: justify;
      .TYSTitle {
        line-height: 100px;
        font-size: 42px;
        font-weight: 700;
        color: #3279b2;
        text-align: center;
        position: relative;
        .shutIcon {
          position: absolute;
          right: 30px;
          top: 0px;
          width: 100px;
          height: 100px;
          img {
            width: 26px;
            height: 26px;
          }
        }
      }
      .TYSList {
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
        font-size: 28px;
        line-height: 42px;
      }
      .TYSPs {
        padding: 30px;
        font-size: 26px;
        line-height: 42px;
        color: #fff;
        background-color: #3279b2;
      }
    }
  }
}
</style>
